export function isUnreachableError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;

  const err = error as {
    response?: { status?: number };
    code?: string;
    message?: string;
  };

  const status = err.response?.status;
  if (status !== undefined) {
    return status >= 500;
  }

  const code = err.code ?? '';
  const networkCodes = [
    'ERR_NETWORK',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ENOTFOUND',
    'ERR_INTERNET_DISCONNECTED',
  ];
  if (networkCodes.includes(code)) return true;

  if (err.message?.includes('timeout')) return true;

  if (error instanceof TypeError) return true;

  return !err.response;
}
